var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-detail__wraper"},[_c('img',{staticClass:"empty-detail__image",attrs:{"src":require("@/assets/images/undraw.png"),"alt":"undraw image"}}),_c('div',{staticClass:"empty-detail__content"},[_c('h6',[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }